import React, { useState } from "react";
import { Link } from "react-router-dom";
import { allRoutes } from "../../routes/routes";
import useLogin from "./useLogin";
import CommonTextInput from "../../components/common/commonTextInput/CommonTextInput";
import i18n from "../../i18n/i18n";

const Login = () => {
  const { formData, onInputDataChange, onLoginHandler } = useLogin();
  const [showPassword, setShowPassword] = useState(false);

  const togglePasswordVisibility = () => {
    setShowPassword((prev) => !prev);
  };

  return (
    <div className="d-flex flex-column flex-root app-root">
      <div className="main-body-cls">
        <section className="login-page">
          <div className="container custom-container">
            <div className="row justify-content-center mt-5">
              <div className="col-lg-4 col-md-6 col-sm-6">
                <div className="card border-0">
                  <div className="ccard-title text-center pt-4">
                    <img
                      src="images/doxbox-logo.png"
                      alt="Logo"
                      width={170}
                      height={30}
                      className="mb-3"
                    />
                    <h2 className="p-3">{i18n.t("login")}</h2>
                  </div>
                  <div className="card-body">
                    <form
                      onSubmit={onLoginHandler}
                      className="form-custm-float-lb"
                    >
                      <div className="mb-5 position-relative">
                        <CommonTextInput
                          name="email"
                          onChange={onInputDataChange}
                          value={formData.email}
                          className="form-control"
                          id="userId"
                          placeholder={i18n.t("enter_email_address")}
                        />
                        <label
                          htmlFor="userId"
                          className="form-label flt-label"
                        >
                          {i18n.t("email_addresse")}
                        </label>
                      </div>
                      <div className="mb-1 position-relative">
                        <CommonTextInput
                          name="password"
                          value={formData.password}
                          className="form-control pe-5"
                          id="password"
                          type={showPassword ? "text" : "password"}
                          placeholder={i18n.t("enter_password")}
                          onChange={onInputDataChange}
                        />
                        <i
                          className={`fa ${showPassword ? "fa-eye" : "fa-eye-slash"} showps`}
                          onClick={togglePasswordVisibility}
                          style={{
                            position: "absolute",
                            right: 10,
                            top: "50%",
                            transform: "translateY(-50%)",
                            cursor: "pointer",
                          }}
                        />
                        <label
                          htmlFor="password"
                          className="form-label flt-label"
                        >
                          {i18n.t("password")}
                        </label>
                      </div>
                      <div className="mb-5 text-end">
                        <Link to={allRoutes.forgotPassword} className="forgot-pass">
                          {i18n.t("forgot_password")} ?
                        </Link>
                      </div>
                      <div className="md-4 text-center">
                        <button
                          type="submit"
                          onClick={onLoginHandler}
                          className="btn btn-info button-drk-info"
                        >
                          {i18n.t("login")}
                        </button>
                      </div>
                      <div className="md-4 text-center">
                        <p className="dnt-ac-tx">
                          {i18n.t("dont_have_an_account")}?{" "}
                          <Link to={allRoutes.signUp}>{i18n.t("sign_up")}</Link>
                        </p>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
};

export default Login;
